import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="addresses"
export default class extends Controller {
  static targets = ["hiddenOrderField", "deliveryAddressText"];

  connect() {

  }

  setOrderDeliveryAddress(event) {
    console.log('asdfasdfasdf');
    const addressId = event.params.addressId;
    this.hiddenOrderFieldTarget.value = addressId;
    this.deliveryAddressTextTarget.outerHTML = event.params.fullText;

    const addressesFrame = document.querySelector("#addresses");

    // Optionally, you can add a class to highlight the selected address
    const currentSelectedAddressButton = addressesFrame.querySelector(".disabled");
    currentSelectedAddressButton.classList.remove("disabled");
    currentSelectedAddressButton.innerText = "choose";

    const selectedAddressElement = event.currentTarget;
    selectedAddressElement.classList.add("disabled");
    selectedAddressElement.innerText = "selected";
  }
}
